import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/lazy-image/lazy-image.tsx
import React from "react";
var LazyImage = ({
  className,
  src,
  srcSet,
  sizes,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "img",
  {
    className: cn(
      "absolute left-0 top-0 h-full w-full object-cover text-transparent transition-opacity lazyload",
      className
    ),
    "data-src": src,
    "data-srcset": srcSet,
    sizes,
    ...props
  }
);

export {
  LazyImage
};
